import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tabs',
  template: `
    <ngb-tabset (tabChange)="tabChange.emit($event)" [activeId]="activeTabId">
      <ngb-tab *ngFor="let tab of tabs" [id]="tab.id">
        <ng-template ngbTabTitle>
          <button class="btn-tab">
            <b>{{ tab.title }}</b>
          </button>
        </ng-template>
        <ng-template ngbTabContent>
          <ng-container *ngTemplateOutlet="tabContent; context: { $implicit: tab }"></ng-container>
        </ng-template>
      </ngb-tab>
    </ngb-tabset>
  `,
})
export class TabsComponent {
  @Input() tabs: any[];
  @Input() activeTabId: string;
  @Output() tabChange = new EventEmitter<any>();
  @Input() tabContent: any;
}
